new Swiper('.image-slider .swiper', {
  slidesPerView: 1.5,
  spaceBetween: 10,
  breakpoints: {
    650: {
      slidesPerView: 2,
    },
    985: {
      slidesPerView: 3,
      spaceBetween: 25,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 50,
    },
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
})
